module.exports = __webpack_public_path__ + "img/GAME_HORSE1.4ed85481.jpg";